import { useQuery } from '@tanstack/react-query';

import { BeneficialOwnerApi } from 'api';
import { DISPENSARY_BENEFICIAL_OWNERS_KEY } from 'hooks/keys';

export function useCrbBeneficialOwners(dispensaryId: string) {
  const beneficialOwnerApi = new BeneficialOwnerApi();

  const { data: beneficialOwners = [], isLoading: isLoadingBeneficialOwners } = useQuery({
    enabled: !!dispensaryId,
    queryKey: [DISPENSARY_BENEFICIAL_OWNERS_KEY, dispensaryId],
    queryFn: () => beneficialOwnerApi.getCrbBeneficialOwners(dispensaryId),
    meta: {
      snackbarErrorMessage: 'There was an issue loading beneficial owners.'
    }
  });

  return { beneficialOwners, isLoadingBeneficialOwners };
}
